module.exports = __webpack_public_path__ + "img/minikube-black.b739e7a9.svg";